// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutScheduleDialog-Dialog_cls1__rdRWQ","cls2":"PayoutScheduleDialog-Dialog_cls2__JPNOC PayoutScheduleDialog-Dialog_cls1__rdRWQ"};